enum ICommunicationType {
  All = 'All',
  Email = 'Email',
  Phone = 'Phone',
  Any = 'Any',
}

export default ICommunicationType;
